import EntityTypeEnum from 'common/enums/entityTypeEnum'
import CustomLoginInterface from 'common/types/entities/CustomLoginInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createNewCustomLogin(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): CustomLoginInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.CustomLogin, parentId, masterBlockId),
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 5,
    },
    childIds: [],
  }
}
